import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/visit";
const API_PATH_ENCOUNTER = ConstantList.API_EN_POINT + "/encounter";

const API_PATH2 = ConstantList.API_EN_POINT + "/voucher";

const API_PATH_REPORT = ConstantList.API_EN_POINT + "/diagnostic-report";

export const saveImageVisitEncounter = (obj) =>
  axios.post(API_PATH + "/add-new-files", obj);

export const getImageVisitEncounterById = (id) =>
  axios.get(API_PATH + "/get-files-by-id/" + id);

export const pagingCheckInSync = (searchObject) =>
  axios.post(API_PATH + "/search-by-page-sync", searchObject);

export const saveExamReg = (visit) =>
  axios.post(API_PATH + "/save-exam-reg", visit);

export const getExamRegById = (patientId) =>
  axios.get(API_PATH + "/exam-reg/" + patientId);

export const pagingExamReg = (searchObject) =>
  axios.post(API_PATH + "/paging-exam-reg", searchObject);

export const pagingExamRegByPatient = (patientId, searchObject) =>
  axios.post(API_PATH + "/paging-exam-reg/" + patientId, searchObject);

export const deleteExamReg = (examRegId) =>
  axios.delete(API_PATH + "/mark-delete-exam-reg/" + examRegId);

export const searchEncounterExamByPage = (searchObject) =>
  axios.post(API_PATH + "/search-encounter-exam-by-page", searchObject);

export const getEhVisitById = (visitId) =>
  axios.get(API_PATH + "/eh-visit/" + visitId);

export const saveEhVisit = (visit) =>
  axios.post(API_PATH + "/save-eh-visit", visit);

export const getRoomEyeExamByVisitId = (visitId) =>
  axios.get(API_PATH + "/get-room-eye-exam-by-visit-id/" + visitId);

export const getLastVisit = (patientId) =>
  axios.get(API_PATH + "/get-last-visit/" + patientId);

export const uploadEyeResultImages = (formData, onUploadProgress) =>
  axios.post(API_PATH + "/upload-photo", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: onUploadProgress,
  });

// export const uploadSingleEyeTestResult = (formData, onUploadProgress) => axios.post(API_PATH + '/upload-single-photo', formData, {
//     headers: {
//         "Content-Type": "multipart/form-data",
//     },
//     onUploadProgress: onUploadProgress
// })

export const uploadSingleEyeTestResult = (file) => {
  let formData = new FormData();
  formData.append("uploadfile", file); //Lưu ý tên 'uploadfile' phải trùng với tham số bên Server side
  return axios({
    url: API_PATH + "/upload-single-photo",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "POST",
    // responseType: "blob",
    data: formData,
  });
};

// axios({
//     method: "post",
//     url: "/api/upload-photo",
//     data: formData,
//     headers: { "Content-Type": "multipart/form-data" },
//   });

export const pagingPatientByCurrentUser = (searchObject) =>
  axios.post(API_PATH + "/paging-patient-by-user", searchObject);
export const saveInternalEncounter = (healthCareRoom, visitId) =>
  axios.post(
    API_PATH + "/save-or-update-internal-exam/" + visitId,
    healthCareRoom ?? { id: null }
  );
//paging encounter reception
export const pagingNewEncounter = (searchObject) =>
  axios.post(API_PATH + "/paging-encounter-new", searchObject);
export const pagingWaittingEncounter = (searchObject) =>
  axios.post(API_PATH + "/paging-encounter-waiting", searchObject);
export const pagingBegingEncounter = (searchObject) =>
  axios.post(
    API_PATH + "/paging-encounter-undergoing-examination",
    searchObject
  );
export const pagingEndEncounter = (searchObject) =>
  axios.post(API_PATH + "/paging-encounter-end", searchObject);
export const saveLabTestResult = (labTestDiagnosticReport, visitId) =>
  axios.post(
    API_PATH + "/save-eh-result-labtest/" + visitId,
    labTestDiagnosticReport ?? { id: null }
  );

//save result image
export const saveResultEhImagingStudy = (diagnosticReport, visitId) =>
  axios.post(
    API_PATH + "/save-eh-diagnostic-image/" + visitId,
    diagnosticReport
  );

// get result image
export const getEhResultImageVisit = (visitId) =>
  axios.get(API_PATH + "/eh-visit-result-image/" + visitId);

//end visit
export const endVisit = (ehVisit) =>
  axios.post(API_PATH + "/end-visit", ehVisit);

export const initExamReg = () => axios.get(API_PATH + "/init-exam-reg");

export const deleteExReg = (examRegId) =>
  axios.delete(API_PATH + "/delete-exam-reg/" + examRegId);
export const pagingEhVisit = (searchObject) =>
  axios.post(API_PATH + "/paging-eh-visit", searchObject);
export const pagingReceptionEncounter = (searchObject) =>
  axios.post(API_PATH + "/paging-reception-encounter", searchObject);
export const getEncounterExamReg = (examRegId) =>
  axios.get(API_PATH + "/encounter-exam-reg/" + examRegId);
export const pagingReceptionServices = (searchObject) =>
  axios.post(API_PATH + "/paging-reception-services", searchObject);
export const getGenEncounterExamReg = (examRegId) =>
  axios.get(API_PATH + "/generality-encounter-exam-reg/" + examRegId);
export const pagingVisit = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

//tổng quát
export const saveGenExamReg = (visit) =>
  axios.post(API_PATH + "/save-generality-exam-reg", visit);
export const saveNewEhVisit = (visit) =>
  axios.post(API_PATH + "/save-new-eh-visit", visit);
//phong kham san
export const saveNewObVisit = (visit) =>
  axios.post(API_PATH + "/save-new-ob-visit", visit);
export const getObVisitById = (visitId) =>
  axios.get(API_PATH + "/get-ob-visit/" + visitId);
export const endObVisit = (ehVisit) =>
  axios.post(API_PATH + "/end-ob-visit", ehVisit);
export const saveGeneralityObVisit = (visit) =>
  axios.post(API_PATH + "/save-generality-ob-visit", visit);
export const getNewObVisitById = (visitId) =>
  axios.get(API_PATH + "/get-new-ob-visit/" + visitId);

//màn hình khám tổng hợp
export const saveGeneralVisit = (dto) =>
  axios.post(API_PATH + "/save-general", dto);
export const getGeneralVisit = (visitId) =>
  axios.get(API_PATH + `/get-general-visit-by-id/${visitId}`);
export const endGeneralVisit = (genVisit) =>
  axios.post(API_PATH + "/end-general-visit", genVisit);

//
export const getPatientRegByVisitId = (visitId) =>
  axios.get(API_PATH + `/get-patient-reg-by-visit-id/${visitId}`);

//visit co nhieu lan kham
export const saveLongVisitDetail = (visit) =>
  axios.post(API_PATH + "/save-long-visit-detail", visit);
export const getGeneralDetailVisitById = (visit) =>
  axios.post(API_PATH + "/get-long-visit-detail", visit);

export const getLongVisitDetailByVisitId = (visitId) =>
  axios.get(API_PATH + "/get-long-visit-detail-by-visit-id/" + visitId);

//save va get visit theo encounter kham
// export const saveLongVisitDetailBySpecialist = (visit) => axios.post(API_PATH + "/save-long-visit-detail-by-specialist", visit)
// export const getLongVisitDetailDaySpecialist = (visit) => axios.post(API_PATH + "/get-long-visit-detail-day-specialist", visit)

//save visit mat viet-nga
export const saveEhVisitDetail = (visit) =>
  axios.post(API_PATH + "/save-eh-visit-detail", visit);
export const saveLongVisitDetailBySpecialist = (visit) =>
  axios.post(API_PATH + "/save-long-visit-detail-by-exam-enc", visit);
export const getLongVisitDetailDaySpecialist = (visit) =>
  axios.post(API_PATH + "/get-long-visit-detail-by-exam-enc", visit);
//get visit
export const getEhVisitCircularByExamEnc = (visit) =>
  axios.post(API_PATH + "/get-eh-visit-circular-by-exam-enc", visit);

export const saveLongVisitDetailByExamEnc = (visit) =>
  axios.post(API_PATH + "/save-long-visit-detail-by-exam-enc", visit);
export const getLongVisitDetailByExamEnc = (visit) =>
  axios.post(API_PATH + "/get-long-visit-detail-by-exam-enc", visit);

export const endGeneralVisitDetail = (genVisit) =>
  axios.post(API_PATH + "/end-general-visit-detail", genVisit);

export const pagingGeneralLongVisit = (dto) =>
  axios.post(API_PATH + "/paging-general-long-visit", dto);
export const saveEncounterTreatmentCare = (dto) =>
  axios.post(API_PATH + "/save-encounter-treatment-care", dto);
export const getEncounterTreatmentCare = (dto) =>
  axios.post(API_PATH + "/get-encounter-treatment-care", dto);
export const getListEncTreatmentCare = (id) =>
  axios.get(API_PATH + "/get-list-encounter-treatment-care/" + id);
export const getsurvivalTreatmentCareByEncounterId = (encounterId) =>
  axios.post(API_PATH + "/get-survival-treatment-care/" + encounterId);
export const pagingListEncTreatmentCare = (searchObject) =>
  axios.post(
    API_PATH + "/search-by-page-survival-treatment-care",
    searchObject
  );
export const deleteEncounterSurvival = (id) =>
  axios.delete(API_PATH + "/mark-delete-encounter-survival/" + id);

//Mở lần khám mới
export const openVist = (id) => axios.post(API_PATH2 + "/open-visit/" + id);

// mo lai encouter
export const openEndEncounter = (genVisit) =>
  axios.post(API_PATH + "/open-end-encounter", genVisit);

// mo lai encouter
export const endEncounter = (genVisit) =>
  axios.post(API_PATH + "/end-encounter", genVisit);

// mo lai visit
export const openEndGeneralVisit = (genVisit) =>
  axios.post(API_PATH + "/open-end-general-visit-detail", genVisit);

// get vtyt
export const getPrescriptionByEncounterId = (obj) =>
  axios.post(API_PATH + "/get-prescription", obj);

export const getPatientRegByPatientId = (id) =>
  axios.get(API_PATH + "/get-patient-reg-by-patient-id/" + id);

export const getLongVisitDetailByVisit = (obj) =>
  axios.post(API_PATH + "/get-long-visit-detail-by-visit", obj);

export const getGeneralMedicationRequests = (obj) =>
  axios.post(API_PATH + "/get-general-medical-supply-request", obj);

export const getGeneralMedicationRequest = (examId) =>
  axios.get(API_PATH + "/get-general-medication-request/" + examId);

export const getGeneralMediSupplyRequest = (examId) =>
  axios.get(API_PATH + "/get-general-medi-supply-request/" + examId);

export const getconsumablesMedicalSupplyRequest = (examId) =>
  axios.get(API_PATH + "/get-comprehensive-medical-supply-request/" + examId);

export const saveGeneralMedicationRequest = (obj, episodeOfCareId) =>
  axios.post(
    API_PATH + "/save-general-medication-request/" + episodeOfCareId,
    obj
  );

export const saveGeneralMedicalSupplyRequests = (obj, episodeOfCareId) =>
  axios.post(
    API_PATH + "/save-general-medical-supply-request/" + episodeOfCareId,
    obj
  );

export const getComprehensiveMedicationRequest = (examId, type) =>
  axios.get(
    API_PATH + "/get-comprehensive-medication-request/" + examId + "/" + type
  );

export const saveComprehensiveMedicationRequest = (obj, episodeOfCareId) =>
  axios.post(
    API_PATH + "/save-comprehensive-medication-request/" + episodeOfCareId,
    obj
  );

export const getDiagReport = (obj) =>
  axios.post(API_PATH_REPORT + "/get-diag-report", obj);

export const getListDiagReport = (obj) =>
  axios.post(API_PATH_REPORT + "/get-list-diag-report", obj);

export const pagingVisitOutByPatientBackLog = (obj) =>
  axios.post(API_PATH + "/get-visit-out-by-patient-back-log", obj);

export const pagingEncounterOutByPatientBackLog = (obj) =>
  axios.post(
    API_PATH_ENCOUNTER + "/get-encounter-out-by-patient-back-log",
    obj
  );

export const uploadAlbum = (files) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("uploadfile", file);
  });

  return axios.post(API_PATH + "/upload-album", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getListPatientFileDescriptions = (id) =>
  axios.get(API_PATH + "/get-list-patient-file-descriptions/" + id);

export const savePatientFileDescriptions = (obj) =>
  axios.post(API_PATH + "/save-patient-file-descriptions", obj);

export const saveConsumablesMedicalSupplyRequests = (obj, episodeOfCareId) =>
  axios.post(
    API_PATH + "/save-comprehensive-medical-supply-request/" + episodeOfCareId,
    obj
  );

export const saveComprehensiveMedicalSupplyRequest = (obj, episodeOfCareId) =>
  axios.post(
    API_PATH + "/save-comprehensive-medical-supply-request/" + episodeOfCareId,
    obj
  );

export const getComprehensiveMedicalSupplyRequest = (id) =>
  axios.get(API_PATH + "/get-comprehensive-medical-supply-request/" + id);

export const voidedVisits = (id) =>
  axios.delete(API_PATH + "/voided-visits/" + id);

export const changeMediReqToOtherRequest = (obj) =>
  axios.post(API_PATH + "/change-medi-req-to-other-request", obj);

export const endListVisit = (obj) =>
  axios.post(API_PATH + "/end-list-visit", obj);

export const openListVisit = (obj) =>
  axios.post(API_PATH + "/open-list-visit", obj);

// cap nhat trang thai visit params: listId, visitStatus
export const updateListVisitStatus = (dto) =>
  axios.post(API_PATH + "/update-visit-status", dto);

export const checkDuplicateHandleSampleCode = (obj) =>
  axios.post(API_PATH + "/check-duplicate-handle-sample-code", obj);

export const exportExcelCheckInReport = (obj) => {
  let url = API_PATH + "/export-excel-check-in-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const voidFileVisit = (id) => axios.post(API_PATH + `/void-file/${id}`);
